import React from 'react';

const arrowImg = (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "red", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M9 19L15 12L9 5", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));

export { arrowImg };
//# sourceMappingURL=arrow_img.js.map
